import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.socialBlacklist],
        config: {
            headerName: getLocalizedString("blockedUserCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.socialBlacklist],
        config:
        {
            headerName: getLocalizedString("blockedUsername"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.socialBlacklist],
        config: {
            headerName: getLocalizedString("lockDate"),
            field: "date",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.socialBlacklist],
        config: {
            headerName: getLocalizedString("userCodeThatBlocked"),
            field: "blockerCode",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.socialBlacklist],
        config:
        {
            headerName: getLocalizedString("userNameThatBlocked"),
            field: "blockerName",
            filter: "agTextColumnFilter",
        }
    },
]